module.exports = __webpack_public_path__ + "static/media/totalizator.818eceed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/totalizator.svg
// module id = 618
// module chunks = 0